//
//
//
//
//
//
//
//
//
//
//
//

import { setting_obj } from '~/settings/setting';
import { formatPath } from '~/utils/tools';
import LazyLoad from './lazy-load'

export default {
  components: {
    LazyLoad
  },
  props: {
    size: {
      type: String,
      default: 'small',
    },
    avatarInfo: {
      type: Object,
      default() {
        return {
          author_avatar: null,
        };
      },
    },
    isLazy: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    showName() {
      const pattern = new RegExp('[\u4E00-\u9FA5]+');
      const name = this.avatarInfo?.author_name || '';
      const isChinese = pattern.test(name);
      if (!name) return '';
      return isChinese ? name.charAt(name.length - 1) : name.charAt(0).toUpperCase();
    },
    avatar() {
      const { author_avatar } = this.avatarInfo;
      const path = formatPath(author_avatar, setting_obj.imageCdnPath);
      return path;
    },
  },
  methods: {
    handleClick() {
      this.$sensors.track('event_click', {
        action_position: 'community',
        action_parameter1: 'avatar',
      });
    }
  }
};
